import { CredentialType, ThirdPartySystemId } from '@pillar-portal/api-types';
import { SecretAssociationCard } from '@/components/payments-infrastructure/SecretAssociationCard';

export function ValorBinLookupConfigEditor(props: {
    readonly organizationUuid: string;
    readonly organizationName: string;
    readonly selectedCredentialUuid: string;
    readonly onSelectedCredentialUuidChange: (credentialUuid: string) => void;
}) {
    return (
        <SecretAssociationCard
            cardTitle="Valor virtual terminal credential"
            entityLabelForDialog="BIN lookup service"
            organizationUuid={props.organizationUuid}
            organizationName={props.organizationName}
            requiredCredentialType={CredentialType.VIRTUAL_TERMINAL}
            requiredCredentialSystemId={ThirdPartySystemId.VALOR_US}
            credentialTargetFamily="ipg"
            credentialSystemSelectLabel="System ID"
            availableCredentialSystemIds={[ThirdPartySystemId.VALOR_US]}
            attachedSecretIdentity={
                props.selectedCredentialUuid === ''
                    ? null
                    : { credential_uuid: props.selectedCredentialUuid }
            }
            canEdit={true}
            onAttachSecret={(secret) => {
                props.onSelectedCredentialUuidChange(secret.credential_uuid);
            }}
            onDetachSecret={() => {
                props.onSelectedCredentialUuidChange('');
            }}
            isMutating={false}
        />
    );
}
